import "./RadioNews.scss";
import RadioImg from "./assets/Images/s3.png";
import CalendarImg from "./assets/Images/calendar.png";
import SectionOneImg from "./assets/Images//hkas_mediation_manual.jpeg";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useEffect, useState } from "react";

const RadioNews = () => {
  const { t } = useTranslation();

  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get("https://www.hkarbsoc.org.hk:9003/api/posts/latest");
        console.log(response.data);
        setBlogs(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <div className="radio-news-container">
        <div className="radio">
          <div className=" text-white rounded-lg">
            <h1 className="text-xl font-bold">{t("radio_program_heading")}</h1>
          </div>
          <div className="background">
            <div className="flex text-center p-3 font-bold">
              <img className="calendar_img" src={CalendarImg} alt="" />
              <span className="mt-1 ml-3">09.05.2017</span>
            </div>
            <p className="font-bold p-2">{t("radio_paragraph1")}</p>
            <img className="radio_img" src={RadioImg} alt="" />
            <p className="mt-2 mb-2">{t("radio_paragraph2")}</p>
            <a href="#/radioprogram"><p style={{ color: "#AD172B", marginTop:'20px', marginBottom:'-10px' }}>{t("view_more")}</p></a>
          </div>
        </div>
        <div className="news">
          <div className=" text-white rounded-lg">
            <h1 className="text-xl font-bold">{t("blog_heading")}</h1>
          </div>
          
          <div className="background">

            <div className="flex flex-row md:flex-row text-center font-bold"
              onClick={() => window.open('#/societynewsdetail/'+blogs?._id, "_self")}
              >
              {/* Left Div */}
              <div className="w-[40%] p-1">
                <img width={'90%'} src={`${blogs.featuredImage}`} alt="" />
              </div>

              {/* Right Div */}
              <div className="w-[60%] p-1">
                <div className="p-6 max-w-4xl mx-auto bg-white border border-gray-200 rounded-lg">
                  <p className="text-2xl font-bold mb-4">
                    {blogs?.title ? blogs.title : ""}
                  </p>
                  <p className="text-gray-500 text-sm mb-4">
                      {blogs?.createdAt ? new Date(blogs.createdAt ? blogs.createdAt : "").toLocaleDateString() : ""}
                  </p>
                  <p
                      className="text-gray-700 leading-7"
                      dangerouslySetInnerHTML={{ __html: blogs?.shortDescription || "" }}
                    />
                </div>
              </div>
            </div>
            
            <a href="#/societynews"><p>{t("view_more")}</p></a>
          </div>
        </div>
      </div>
    </>
  );
};

export default RadioNews;
